module.exports = __webpack_public_path__ + "static/06-f8bb6bba90e23e4c86a6e798261aeb95.jpg";